// extracted by mini-css-extract-plugin
export default {"title":"LoginPage_title__TEgJs","gradient-animation":"LoginPage_gradient-animation__OxVTp"};